import { AbstractControl, ValidationErrors } from '@angular/forms';

export const PhoneValidator = (control: AbstractControl): ValidationErrors => {
  const PHONE_REGEXP = /^\+?[0-9\s\-()]+$/;

  if (control.value && !PHONE_REGEXP.test(control.value.toString())) {
    return {
      invalidPhone: true
    };
  }

  return null;
};
